<div class="row">
    <div class="col-12">
        <swiper [config]="responsiveNoOverflowConfig" (swiper)="onResourcesSwiper($event)"
            class="w-100 responsive-no-overflow-swiper">
            <ng-template swiperSlide *ngIf="!loadedPosts">
                <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                    'height': '300px',
                    'width': '100%'
                }"></ngx-skeleton-loader>
            </ng-template>
            <ng-template swiperSlide *ngIf="!loadedPosts">
                <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
                    'height': '300px',
                    'width': '100%'
                }"></ngx-skeleton-loader>
            </ng-template>
            <ng-template swiperSlide *ngFor="let post of posts">
                <app-post-item id="{{ post.id }}" image="{{ post.image }}" title="{{ post.title }}"
                    slug="{{ post.slug }}" summary="{{ post.summary }}" date="{{ post.date }}" [tagged]="post.tagged"
                    swiperEnabled="true"></app-post-item>
            </ng-template>
        </swiper>
    </div>
</div>

<div class="row pb-10">
    <div class="col-12 text-center d-lg-flex justify-content-end">
        <a routerLink="/notice-board">
            <button type="button" class="btn btn-lg btn-outline-primary border-primary border-2 rounded-pill font-size-16 font-weight-bold text-right">
                View Notice Board
                <!--<img loading="lazy" src="assets/img/icons/icn-arrow-forward-blue.svg" width="15" />-->
                <i class="material-symbols-outlined">east</i>
            </button>
        </a>
    </div>
</div>